// @ts-nocheck
import type { BoxProps } from "@mui/material/Box";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { UploadIllustration } from "#src/assets/illustrations";

// ----------------------------------------------------------------------

export function UploadPlaceholder({ ...other }: BoxProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
      {...other}
    >
      <UploadIllustration hideBackground sx={{ width: 150 }} />

      <Stack spacing={1} sx={{ textAlign: "center" }}>
        <Box sx={{ typography: "h6" }}>Kéo thả vào đây</Box>
        <Box sx={{ typography: "body2", color: "text.secondary" }}>
          hoặc
          <Box
            component="span"
            sx={{
              typography: "body2",
              mx: 0.5,
              color: "primary.main",
              textDecoration: "underline",
            }}
          >
            Tải lên
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
